import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, ViewChild, AfterViewInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { addAttachment, deleteAttachment, getAllAttachment, updateAttachment } from 'src/app/core/store/attachment.action';
import { Observable, Subject, concatMap, filter, lastValueFrom, take, takeUntil } from 'rxjs';
import { BackendApiService } from 'src/app/core/services/backend-api';
import {
  deleteDraftItemFromMyPurchase,
  deleteItemFromMyPurchase,
  addItemtoMyPurchase
} from 'src/app/core/store/form.actions';
import { doesNotMeetRfsCriteria } from 'src/app/modules/shared/utils/check-rfs-criteria';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { RfsSourcingResponse } from 'src/app/shared/components/global-banner/dto/rfs-sourcing-response.model';
import {
  DropDownOptions,
  IItemToRequest,
  MyPurchaseForm,
  StoreDropdowns,
  UserInformation,
  FileInformation,
} from 'src/app/shared/models/app-models';
import { FormTransformerPipe } from 'src/app/shared/pipes/form-transformer/form-transformer.pipe';
import SourcingStatusJSON from 'src/app/data/constants/SourcingStatus.json';
import { Vendor } from 'src/app/shared/models/database-models/SaveMyPurchase.model';
import { CurrencyExchange } from 'src/app/shared/models/database-models/CurrencyExchange.model';
import { addCurrencyExchange } from 'src/app/core/store/CurrencyExchange.action';
import { updateRfsOutcomes } from 'src/app/core/store/DeletedItemVendors.action';
import { DeletedItemVendorsState, deletedItemVendorsReducer } from 'src/app/core/store/DeletedItemVendors.reducer';
import { PermissionsService } from 'src/app/core/services/permissions/permission.service';
import { PurchaseTypeMap } from 'src/app/shared/models/app-models/Approving.model';
import { environment } from 'src/environments/environment';
import { ItemUploadTemplateComponent } from './item-upload-template/item-upload-template.component';
import { IItemTable, itemToTableDisplay, getItemTotalAmountInItemCurrency } from 'src/app/modules/shared/utils/format-form-data-for-display';
import { AttachmentComponent, AttachmentData } from 'src/app/modules/mypurchase-form/attachments/attachment.component';
import { CurrencyService } from 'src/app/shared/services/currency.service';

export interface IitemRequestTable extends IItemTable {
  index: number;
}

@Component({
  selector: 'app-item-list',
  templateUrl: './item-list.component.html',
  styleUrls: ['./item-list.component.scss'],
  providers: [
    {
      provide: DatePipe,
    },
    {
      provide: DecimalPipe,
    },
  ],
})
export class ItemListComponent {
  @Output() itemCost = new EventEmitter<string>();
  readonly permissionData$: Observable<any>
  @ViewChild('attachment') attachmentComponent!: AttachmentComponent;
  purchaseTypeMap = PurchaseTypeMap
  itemCostValue: string = "";
  @Input() isReadOnly: boolean = false;
  mpNumber: string = '';
  columns = [
    {
      columnDef: 'displayItemNumber',
      header: 'Item No.',
      cell: (element: IitemRequestTable) => `${element.displayItemNumber === 0 ? '-' : element.displayItemNumber}`,
    },
    {
      columnDef: 'SourcingStatus',
      header: 'Sourcing Status',
      cell: (element: IitemRequestTable) => `${element.SourcingStatus}`,
    },
    {
      columnDef: 'MaterialSubGroupId',
      header: 'Material Sub-Group',
      cell: (element: IitemRequestTable) => `${element.MaterialSubGroupId}`,
    },
    {
      columnDef: 'ItemDescription',
      header: 'Item Description',
      cell: (element: IitemRequestTable) => `${element.ItemDescription}`,
    },
    {
      columnDef: 'Quantity',
      header: 'Quantity',
      cell: (element: IitemRequestTable) => `${element.Quantity}`,
    },
    {
      columnDef: 'UnitOfMeasurement',
      header: 'UOM',
      cell: (element: IitemRequestTable) => `${element.UnitOfMeasurement}`,
    },
    {
      columnDef: 'Currency',
      header: 'Currency',
      cell: (element: IitemRequestTable) => `${element.Currency}`,
    },
    {
      columnDef: 'UnitPrice',
      header: 'Est Unit Price',
      cell: (element: IitemRequestTable) => `${element.UnitPrice}`,
    },
    {
      columnDef: 'TotalAmount',
      header: 'Est. Item Amount',
      cell: (element: IitemRequestTable) => `${element.TotalAmount}`,
    },
    {
      columnDef: 'PartModelNumber',
      header: 'Part No./Model No.',
      cell: (element: IitemRequestTable) => `${element.PartModelNumber}`,
    },
    {
      columnDef: 'PlannedDeliveryDate',
      header: 'Planned Delivery Date',
      cell: (element: IitemRequestTable) =>
        this.formatDate(`${element.PlannedDeliveryDate}`),
    },
    {
      columnDef: 'Actions',
      header: 'Actions',
      cell: (element: IitemRequestTable) => '',
    },
  ];
  tableData: IitemRequestTable[] = [];
  itemList: IItemToRequest[] = [];
  vendorForm!: Vendor[];
  docStatus!: number | null;
  docSubStatus!: number | null;
  createdBy!: string | null;
  RO!: string | null;
  isReferenced: boolean = false;
  isDocComplete: boolean = false;
  loggedInUser!: UserInformation
  childDocument :boolean = false;
  dataSource = new MatTableDataSource<IitemRequestTable>(this.tableData);
  selection = new SelectionModel<IitemRequestTable>(true, []);
  // filter out columns according to the user choice
  displayedColumns = this.columns
    .filter(column => column.columnDef !== 'SourcingStatus')
    .map(c => c.columnDef);
  estTotalAmt: string = '0.00';
  destroy$: Subject<boolean> = new Subject<boolean>();
  pageSizeOptions: number[] = [5, 10, 20, 50];
  purchaseType: string = '';
  storeDropdowns?: StoreDropdowns;
  deactivatedItems: IItemToRequest[] = [];
  fileFormStore: FileInformation[] = [];
  form?: MyPurchaseForm
  currencyExchangeRates: CurrencyExchange[] = [];
  ExchangeRateLock: boolean = false;
  deletedItemVendors?: DeletedItemVendorsState
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(
    private datePipe: DatePipe,
    private store: Store<{
      form: MyPurchaseForm; dp: StoreDropdowns, user: UserInformation, currency: CurrencyExchange[],
      deletedItemVendors: DeletedItemVendorsState, attachment: FileInformation[]
    }>,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<DialogComponent>,
    private decimalPipe: DecimalPipe,
    private router: Router,
    private backendService: BackendApiService,
    private transformer: FormTransformerPipe,
    private route: ActivatedRoute,
    private permissionsService: PermissionsService,
    private currencyService: CurrencyService,
  ) {
    this.permissionData$ = permissionsService.getService().pipe(takeUntil(this.destroy$))
    this.mpNumber = route.snapshot.params['id'].split(';')[0];
    this.purchaseType = route.snapshot.params['purchaseType'].split(
      ';'
    )[0] as string;
    this.store.select('currency').pipe(takeUntil(this.destroy$)).subscribe((currencies: CurrencyExchange[]) => {
      this.currencyExchangeRates = currencies
    })
    var dp$ = this.store
      .select('dp')
      .pipe(filter(x => { return x.AttachmentExtensions.length > 0 }), take(1)).pipe(concatMap((dp: StoreDropdowns) => {
        if (!this.storeDropdowns) {
          this.storeDropdowns = dp
        }
        return this.store
          .select('form')
          .pipe(takeUntil(this.destroy$))

      })).subscribe(async (form: MyPurchaseForm) => {

        this.itemList = form.ItemList.concat(this.deactivatedItems);
        this.childDocument = form.parentDocumentNo ? true : false;
        this.docStatus = form.documentStatusId;
        this.docSubStatus = form.documentSubStatusId;
        this.createdBy = form.createdBy;
        this.RO = form.generalForm.RO.id;
        this.vendorForm = form.VendorsToSource;
        this.ExchangeRateLock = form.ExchangeRateLock;
        this.convertToTable(this.itemList).then(value => {
          this.tableData = value
          this.dataSource = new MatTableDataSource<IitemRequestTable>(
            this.tableData
          );
          this.dataSource.paginator = this.paginator;
          this.checkForSourcing();
        });
        if (form.documentStatusId == 3 && form.documentSubStatusId == 2) this.checkForReferenceID();
        if (this.docStatus == 5 && this.docSubStatus == 64) this.isDocComplete = true;
      });
    this.store.select('user').pipe(takeUntil(this.destroy$)).subscribe((user) => {
      this.loggedInUser = user;
    })

    this.store
      .select('attachment')
      .pipe(takeUntil(this.destroy$))
      .subscribe((files: FileInformation[]) => {
        this.fileFormStore = files
      });

  }
  async ngOnInit() {
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  checkForSourcing() {
    const filteredItemList = this.itemList.filter((item: any) => !item.isDeleted && !item.Strikethrough);
    let isCOTS = filteredItemList.every(item => item.AddItems.isCOTS?.value === 'COTS');
    console.log("isCOTS : ", isCOTS);

    let totalPrice = 0;
    if (isCOTS) {
        for (let i = 0; i < filteredItemList.length; i++) {
            totalPrice += (filteredItemList[i].ItemPrice.UnitPrice * filteredItemList[i].ItemPrice.Quantity) / filteredItemList[i].ItemPrice.UnitsPerQuantity;
        }
    }
    if ((isCOTS && totalPrice > 6000) && (( this.purchaseType === 'rfq' && this.form?.generalForm?.reasonForNotUsingRFQ?.value === environment.optForRFQReasonCode) || this.purchaseType === 'corporatecard')) {
      this.displayedColumns = this.columns.map((c) => c.columnDef);
    } else {
      this.displayedColumns = this.columns
        .filter(column => column.columnDef !== 'SourcingStatus')
        .map(c => c.columnDef);
    }
  }
  checkForReferenceID() {
    this.isReferenced = this.itemList.some((item: any) => item.AddItems.ReferenceId);
  }
  navigateToAddItem(row: any, event?: any) {
    if(event) {
      event.stopPropagation();
    }
    if (row == 0) {
      this.router.navigate([this.router.url.split(';')[0], 'add']);
    } else {
      this.router.navigate([this.router.url.split(';')[0], 'edit', row.itemId]);
    }
  }
  itemReferenceOnClickHandler() {
    throw new Error('Method not implemented.');
  }
  isAllSelected(): import('@angular/cdk/coercion').BooleanInput {
    throw new Error('Method not implemented.');
  }
  masterToggle() {
    throw new Error('Method not implemented.');
  }
  openDialog(record: any, event?:any) {
    if(event) {
      event.stopPropagation();
    }
    console.log(this.dataSource.data.length)
    if (this.dataSource.data.length == 1) {
      alert("There is only one item left. Unable to delete.");
      return;
    }
    this.dialogRef = this.dialog.open(DialogComponent, {
      // height: '200px',
      // width: '450px',
      panelClass: 'item-vendor-dialog',
      hasBackdrop: true,
      data: {
        headerTitle: 'Discard item record?',
        contentMsg: 'This action cannot be undone.',
        btnNameOne: 'Discard',
        btnNameTwo: 'Cancel',
        click: () => {
          this.deleteItem(record);
          this.dialogRef.close();
        },
        clickTwo: () => {
          this.dialogRef.close();
        }
      },
    });
  }
  openCopyDialog(record: any, event?: any) {
    if (event) {
      event.stopPropagation();
    }
    console.log(record)
    this.dialogRef = this.dialog.open(DialogComponent, {
      // height: '200px',
      // width: '450px',
      panelClass: 'item-vendor-dialog',
      hasBackdrop: true,
      data: {
        headerTitle: 'Copy item no .' + record.index + '?',
        contentMsg: 'Do you wish to create a copy of item no. ' + record.index + '?',
        btnNameOne: 'Copy',
        btnNameTwo: 'Cancel',
        click: () => {
          this.copyItem(record.index);
          this.dialogRef.close();
        },
        clickTwo: () => {
          this.dialogRef.close();
        }
      },
    });
  }
  copyItem(indexs: any) {
    let currList = this.itemList.filter((item)=>{return item.isDeleted  === false && item.Strikethrough === false})
    const index = indexs - 1;
    console.log("index", index);
    console.log(this.itemList[index]);
    const newItemId = this.itemList.length + 1;
    const maxDisplayItemNumber = Math.max(0, ...currList.map(item => item?.AddItems?.displayItemNumber ?? 0))
    const newDisplayItemNumber = maxDisplayItemNumber + 1;
    const newItemToAdd: IItemToRequest = {
      AddItems: {
        ...currList[index].AddItems,
        itemId: newItemId,
        displayItemNumber: newDisplayItemNumber,
        PurchaseItemId: null
      },
      ItemPrice: currList[index].ItemPrice,
      BudgetAllocation: this.CopyItemPurchaseNoForBudgetList(
        currList[index].BudgetAllocation,
        newItemId,
        newDisplayItemNumber
      ),
      isDeleted: false,
      Strikethrough: false,
      AddOnFeature: currList[index]?.AddOnFeature ? this.CopyAddOnFeatues(currList[index]?.AddOnFeature):[]
    };
    this.store.dispatch(addItemtoMyPurchase({ form: newItemToAdd }));
  }
  deleteItem(record: IitemRequestTable) {
    console.log(record);
    let checkkDraftItem: boolean = false;
    if (this.mpNumber == 'draft') {
      console.log('called draft');
      this.store.dispatch(
        deleteDraftItemFromMyPurchase({ itemId: record.itemId })
      );
      checkkDraftItem = true
    } else {
      console.log('called real item');
      this.store.dispatch(deleteItemFromMyPurchase({ itemId: record.itemId }));
      if ((this.docStatus === 3 && this.docSubStatus === 1) || (this.docStatus === 2 && this.docSubStatus === 2)) { // New OR Draft Case
        checkkDraftItem = true
      } else { //Submitted before
        if (record.PurchaseItemId) {
          checkkDraftItem = false
        } else {
          checkkDraftItem = true
        }
      }
    }


    this.fileFormStore.map((item: FileInformation, index) => {
      let updatedItems
      // updatedItems = item.items.filter((id: number) => id !== record.itemId);
      updatedItems = item.attachment.TaggedItems?.filter((displayItemNumber: number) => displayItemNumber !== record.displayItemNumber);
      updatedItems = updatedItems?.map((displayItemNumber: number) => 
        displayItemNumber >= record.displayItemNumber && checkkDraftItem ? displayItemNumber - 1 : displayItemNumber
      );
      const updatedItemsStr = Array.isArray(updatedItems) && updatedItems.length > 0 ? updatedItems.join(',') : '';
      let fileCopy:FileInformation =  {
        ...item,
        attachment:{
          ...item.attachment,
          TaggedItems: updatedItems
        },
        tableInformation: {
            ...item.tableInformation,
            TaggedItems: updatedItemsStr
        }
      };
      this.store.dispatch(updateAttachment({ file: fileCopy, index: index }));
    });
  }

  formatDate(date: any): string {
    if (date && !isNaN(new Date(date).getTime())) {
      return this.datePipe.transform(date, 'dd/MM/yyyy') ?? date;
    }
    return date;
  }

  updateEstCost(value: string) {
    this.itemCostValue = value;
    setTimeout(() => {
      this.itemCost.emit(this.itemCostValue);
    }, 1000)
  }
  async convertCurrencyToSGD(amount: number, currCode: string, exchangeRateCurrency: number) {
    let exchangeRate
    if (currCode == 'SGD') return amount
    let currEx = this.currencyExchangeRates.find(x => x.FromCurrency == currCode)
    if (!currEx) {
      const resp: CurrencyExchange = await lastValueFrom(this.backendService.getCurrencyExchange(currCode));
      currEx = resp
      this.store.dispatch(addCurrencyExchange({ currency: resp }))
    }
    if (this.ExchangeRateLock) {
      exchangeRate = exchangeRateCurrency;
    } else if (this.docStatus === 2 || this.docStatus === 3 || this.docStatus === 6) {
      exchangeRate = currEx!.Rate;
    } else {
      exchangeRate = exchangeRateCurrency;
    }
    return (amount * (exchangeRate / currEx.RatioForTheFromCurrencyUnits))
  }
  async convertToTable(itemList: IItemToRequest[]) {
    let tableTable: IitemRequestTable[] = [];
    let estimatedTotal: number = 0.0;
    let index = 1;
    for (const item of itemList) {
      let totalAmountInItemCurrency = getItemTotalAmountInItemCurrency(item);

      //convert totalAmountInItemCurrencyToSGD
      if (!item.isDeleted && !item.Strikethrough) {
        let totalAmount = await this.currencyService.convertAsyncCurrencyToSGD(totalAmountInItemCurrency, item.ItemPrice.Currency.value, item.ItemPrice.ExchangeRate) ?? 0
        estimatedTotal += totalAmount;
      }


      let tableObj: IitemRequestTable = {
        index: index,
        ...itemToTableDisplay(item, this.decimalPipe)
      };
      if ((!item.isDeleted && !item.Strikethrough) || this.docStatus != 3) {
        index += 1;
      }

      tableTable.push(tableObj);
    }
    this.estTotalAmt =
      this.decimalPipe.transform(estimatedTotal, '1.2-2') ?? '0.00';
    this.updateEstCost(this.estTotalAmt);
    return tableTable;
  }
  CopyItemPurchaseNoForBudgetList(budgetList: any[], newItemId: any, newDisplayItemNumber: any) {
    let newList: any[] = [];

    for (const budget of budgetList) {
      newList.push({
        ...budget,
        PurchaseItemNo: newItemId,
        displayPurchaseItemNumber: newDisplayItemNumber,
        BudgetItemId: null
      });
    }
    return newList;
  }

  CopyAddOnFeatues(addOnInfo: any) {
    let newList: any[] = [];
    for (const addOn of addOnInfo) {
      newList.push({
        ...addOn,
        PurchaseItemId: null,
        ItemAddOnId: null
      });
    }
    return newList;
  }
  async downlaodtemplate() {
    try {
      // let data: any = await lastValueFrom(this.backendService.getItemTemplateExcelFile());
      // const arrayBuffer: any = data.attachment.data;
      // const int8Array = new Uint8Array(arrayBuffer);
      // let blob = new Blob([int8Array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      // const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      // a.href = url;
      a.href = environment.downloadTemplateUrl
      // const finalName = this.mpNumber !== 'draft' ? this.mpNumber + "_" + environment.itemDownloadTemplateName : environment.itemDownloadTemplateName
      // a.download = finalName;
      // a.click();
      // window.URL.revokeObjectURL(a.href);
      window.open(a.href, '_blank');
    } catch (e) {
      alert('error downloading');
    }
  }

  uploadTemplate() {
    let dialogRef = this.dialog.open(ItemUploadTemplateComponent, {
      width: '680px',
      maxHeight: '85vh'
      // data: {
      //   filename: file.attachment.FileName,
      //   selectedPurposeDropdownsArray: file.selectedPurposeDropdowns,
      //   selectedPurpose: file.selectedPurpose
      // }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        console.log(result)
        // let realIndex = this.paginator.pageIndex * this.paginator.pageSize + index;
        // // update the purpose of the file
        // let fileCopy = structuredClone(file);
        // fileCopy.attachment.AttachmentTypeId = Number(result.selectedPurpose ?? 0) ;
        // fileCopy.tableInformation.Purpose = result.selectedPurpose ?? "";
        // fileCopy.tableInformation.ItemsTagged = result.records.map((res:any) =>{
        //   return res.itemId
        // });
        // fileCopy.attachment.TaggedItems = result.records.map((res:any) =>{
        //   return res.itemId
        // });
        // fileCopy.items = result.records;
        // this.store.dispatch(updateAttachment({ file: fileCopy, index: realIndex }));
      }
    });
  }

  // return enable state whenever the condition is met
  getViewActionState(type: string, data: any, noUpdatePerm: boolean) {
    let state = false;

    if((((!data.isDeleted && !data.Strikethrough) || this.isDocComplete) && (this.isReadOnly && noUpdatePerm)  || this.isReferenced ) || this.childDocument) {
      state = true
    }

    if(type === "delete") {
      state = state && (this.docSubStatus == 52 && (this.RO == this.loggedInUser.userName || this.createdBy== this.loggedInUser.userName));
    }

    return state;
  }

  // return disable state whenever the condition is met
  getUpdateActionState(data: any, hasUpdatePerm: boolean, additionalPermCheck?: boolean) {
    let state = false;

    if((!hasUpdatePerm && this.isReadOnly) || this.childDocument || this.isReferenced || data?.isDeleted || data?.Strikethrough) {
      state = true;
    }

    if(additionalPermCheck != undefined && (!additionalPermCheck && this.isReadOnly)) {
      state = true;
    }

    return state;
  }

  onTableScroll(event: any):void {
    const element: HTMLDivElement = event.target;
    let scroll = Math.ceil(element.scrollLeft) || 0;
    let end = element.scrollWidth - element.clientWidth;
    let classList = element.classList;

    if (scroll == 0) {
      // scrolled to the left most
      this.updateTableClassList(classList, "scrollable-table-left");
    } else if (scroll >= (end - 1)) {
      //scrolled to the right most
      this.updateTableClassList(classList, "scrollable-table-right");
    } else  if (scroll < end) {
      // in between
      this.updateTableClassList(classList, "scrollable-table-middle");
    }
  }

  updateTableClassList(classList: DOMTokenList, key: string) {
    const rightClass = "scrollable-table-right";
    const leftClass = "scrollable-table-left";
    const middleClass = "scrollable-table-middle";

    if(classList.contains(rightClass)) {
      classList.replace(rightClass, key);
    }
    else if(classList.contains(middleClass)) {
      classList.replace(middleClass, key);
    }
    else if(classList.contains(leftClass)) {
      classList.replace(leftClass, key);
    } else {
      classList.add(key);
    }
  }
}
